import { Route, Routes } from "react-router-dom";

import { SubscriptionEmailLink } from "../../pages";

export const SubAndEmailLinkLayout = () => {
  return (
    <Routes>
      <Route path="/" element={<SubscriptionEmailLink/>} />
    </Routes>
  );
};
